import { computed } from 'vue'
import {useStore} from 'vuex'
import GetLabel from "foundation/js/getLabel"

export default {
    name: "FileListCard",
    props: {
        cardData: {
            type: Object,
            required: true
        },
        cardButtonIcons: {
            type: Object,
            required: true,
            default: false
        }
    },
    setup(props){
        const store = useStore()

        const exitOnEscape = function (e) {
            const currentCardElement = e.target.parentNode.parentNode
            const currentCardFileLink = currentCardElement.querySelector('.kb-js--file-link')
            const currentCardFunctions = currentCardElement.querySelectorAll('.kb-js--file-function')
            
            currentCardFileLink.focus()

            currentCardFunctions.forEach((functionButton)=> {
                functionButton.setAttribute('tabindex', -1)
            })
        }

        const enterFunctions = function (e){
            const currentCardElement = e.target.parentNode
            
            const currentCardFunctions = currentCardElement.querySelectorAll('.kb-js--file-function')

            if(!currentCardFunctions.length) {
                return false
            }

            currentCardFunctions[0].focus()

            currentCardFunctions.forEach((functionButton, index)=> {
                functionButton.setAttribute('tabindex', 0)

                if(currentCardFunctions.length -1 === index) {
                    functionButton.addEventListener('keydown', (e)=> {

                        if(e.code === 'Tab' && e.shiftKey === false) {
                            currentCardFunctions.forEach((functionButton)=> {
                                functionButton.setAttribute('tabindex', -1)
                            })
                        }

                    })
                }

                if(index === 0) {
                    functionButton.addEventListener('keydown', (e)=> {
                        if(e.code === 'Tab' && e.shiftKey === true) {
                            currentCardFunctions.forEach((functionButton)=> {
                                functionButton.setAttribute('tabindex', -1)
                            })
                        }

                    })
                }
            })
            
            
        }

        const getLabel = (labelKey, params) => GetLabel({ labelKey, labelCollection: 'FileListCard', params })
        const getLabelOrEmpty = (labelKey, params) => GetLabel({ labelKey, labelCollection: 'FileListCard', params, allowEmpty: true })

        const activeActionTarget =  computed(() => props.cardData.type == 'Dokument' ? "_blank" : null);

        const determineStartOverlayFunction = function (e, currentOverlay, cardData) {
            // the active overlay mode should be set when overlay activated
            // when overlay closed, mode needs to be cleared
            store.dispatch('frivillige/setActiveOverlayMode', { mode: cardData.type })  
            store.dispatch('frivillige/setActiveItemName', { name: cardData.name })  
            store.dispatch('frivillige/setEditModeActive', { mode: true }) 
            store.commit('frivillige/set_active_item_id',  cardData.id)   

            // for prefilled in edit mode - creating updated active_name
            store.dispatch('frivillige/getActiveItemName')

            if(currentOverlay === "ConfirmDeleteOverlay") {
    
                store.commit('frivillige/set_delete_item_type', cardData.type )  
                store.commit('frivillige/set_delete_item_id',  cardData.id )  
                store.commit('frivillige/set_delete_item_name', cardData.name)  
            }
            
            store.dispatch('main/openPageOverlay',{
                    overlayContent: currentOverlay,
                    returnTarget: e.currentTarget
            })
          
        }

        return {
            activeActionTarget,
            enterFunctions,
            determineStartOverlayFunction,
            exitOnEscape,
            getLabel,
            getLabelOrEmpty
        }
        
    }
}